// 3rd party imports
import * as React from 'react';

// bernie
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkFullscreenDialog, UitkDialogContent } from 'uitk-react-dialog';
import { UitkToolbar, ToolbarType } from 'uitk-react-toolbar';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

// util
import { UitkList } from 'uitk-react-list';

export interface PzTermsDialogProps {
  dialogId: string;
  l10n?: ILocalization;
  routeStore: RouteStore;
  terms: string;
}

export const PzTermsDialog: React.FunctionComponent<PzTermsDialogProps> = ({ dialogId, l10n, routeStore, terms }) => {
  const onDismiss = () => {
    routeStore.closeDialog();
  };

  const dialogHeading = 'pz.signup.info.dialog.commission.title';

  const dialogContent = (
    <UitkDialogContent>
      <div dangerouslySetInnerHTML={{ __html: terms }} />
    </UitkDialogContent>
  );

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogPzTerms" onDismiss={onDismiss}>
          <UitkFullscreenDialog returnFocusOnClose={true}>
            <UitkToolbar
              action={onDismiss}
              header="Partnerized Terms & Conditions"
              iconLabel={l10n.formatText('close')}
              key="pzTermsToolbar"
              type={ToolbarType.CLOSE}
            />
            {dialogContent}
          </UitkFullscreenDialog>
        </Layer>
      </DialogRoute>
    </>
  );
};
